import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { VideoRequestData } from "types/incident/video-request";

interface IncidentState {
    retryVideoRequestData: VideoRequestData | null;
}

const initialState: IncidentState = {
    retryVideoRequestData: null,
};

const slice = createSlice({
    name: "incident",
    initialState,
    reducers: {
        setRetryVideoRequestData(state, action: PayloadAction<VideoRequestData>) {
            state.retryVideoRequestData = action.payload;
        },
        clearRetryVideoRequestData(state) {
            state.retryVideoRequestData = null;
        },
    },
});

export const { setRetryVideoRequestData, clearRetryVideoRequestData } = slice.actions;
export default slice.reducer;
